import { BadgeV3, ButtonV2 } from '@cimplico/components';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { FileContextEnum, PathNode } from '../../types/file-record';
import { getRedirectPath } from './file-utils';

type FilePathSectionProps = {
    isCurrent?: boolean;
    inContext?: boolean;
    filePath: PathNode[];
    onGoToFolder: (folderId: string, activeFileId?: string) => void;
};

function FilePathSection({ isCurrent = false, inContext = false, onGoToFolder, filePath }: FilePathSectionProps): JSX.Element {
    const navigate = useNavigate();
    const { shortId } = useFirmContext();

    const parentFolder = filePath[filePath.length - 2];
    const activeFileId = filePath[filePath.length - 1].id;

    function redirectToContext(): void {
        const redirectPath = getRedirectPath(filePath, parentFolder.id, parentFolder.context);

        if (redirectPath !== undefined) {
            navigate(`/${shortId}${redirectPath}&activeFile=${activeFileId}`);
            onGoToFolder(parentFolder.id, activeFileId);
        }
    }

    return (
        <div className="border-b py-3 flex flex-col gap-2">
            {isCurrent && (
                <div>
                    <BadgeV3 color="indigo" label="Current" size="small" />
                </div>
            )}
            <div className="text-gray-500 text-xs flex gap-0.5 items-center flex-wrap">
                {filePath.map((p, idx) => {
                    return (
                        <div className="flex gap-0.5 items-center" key={idx}>
                            <p>{p.name}</p>
                            {idx !== filePath.length - 1 && <ChevronRightIcon className="w-4 h-4" />}
                        </div>
                    );
                })}
            </div>
            {!inContext && parentFolder.context !== FileContextEnum.FIRM && (
                <div className="flex gap-2">
                    {parentFolder.context && <ButtonV2 label="Go to location" size="xs" type="secondary" onClick={redirectToContext} />}
                    {!isCurrent && (
                        <div>
                            <ButtonV2
                                label="Go to folder"
                                size="xs"
                                type="secondary"
                                onClick={(): void => onGoToFolder(parentFolder.id, filePath[filePath.length - 1].id)}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default FilePathSection;
